import ReportsContainer from './ReportsContainer';

export default ReportsContainer;
